import React, { useEffect, useState } from "react";
import HeaderTitle from "../HederTitle/HeaderTitle";
import { Link } from "react-router-dom";
import { currency } from "../../App";
import axios from "axios";
import { backend_url } from "../../App";
import LazyVideo from "../LazyVideo/LazyVideo";

const RetroCollection = () => {
  const [bestSellers, setBestSellers] = useState([]);

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const response = await axios.get(`${backend_url}/api/topsellerretro`);
        const filteredSellers = response.data.filter(
          (item) => item.placeTo === "Retro Collections"
        );
        setBestSellers(filteredSellers);
      } catch (error) {
        console.error("Error fetching Retro Collections:", error);
      }
    };
    fetchBestSellers();
  }, []);

  return (
    <div
      className="relative overflow-hidden px-4 sm:px-8 py-8"
      style={{ background: "linear-gradient(180deg, var(--brand-surface) 0%, var(--brand-bg) 100%)" }}
    >
      <div className="relative max-w-7xl mx-auto">
        <HeaderTitle Header="Retro Collections" />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-4">
          {bestSellers.map((item) => (
            <Link
              key={item._id}
              to={`/product/${item.productId?.id}/${item.productId?.name}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group flex flex-col rounded-2xl overflow-hidden shadow-md border-2 border-[var(--brand-primary-100)]
                         hover:shadow-[0_8px_28px_rgba(124,58,237,0.22)]
                         hover:border-[var(--brand-primary-400)]
                         hover:-translate-y-1.5
                         transition-all duration-300 bg-white"
            >
              {/* Video */}
              <div className="relative h-72 sm:h-80 overflow-hidden">
                <LazyVideo
                  key={item.video}
                  src={item.video}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                {/* Retro badge */}
                <div className="absolute top-3 left-3">
                  <span className="bg-[var(--brand-primary-700)] text-white text-[10px] font-bold px-2.5 py-1 rounded-full">
                    RETRO
                  </span>
                </div>
              </div>

              {/* Product info */}
              <div className="p-3 flex flex-col gap-1">
                <p className="text-sm font-semibold text-gray-800 truncate">
                  {item.productId?.name}
                </p>
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-[var(--brand-primary-700)] font-bold text-sm">
                    {currency}{item.productId?.old_price && Math.round((item.productId.old_price * (100 - item.productId.new_price)) / 100)}
                  </span>
                  {item.productId?.old_price && (
                    <>
                      <span className="text-gray-400 line-through text-xs">₹{item.productId.old_price}</span>
                      <span className="bg-green-100 text-green-700 text-[10px] font-bold px-2 py-0.5 rounded-full">
                        {item.productId.new_price}% OFF
                      </span>
                    </>
                  )}
                </div>
              </div>
            </Link>
          ))}

          {bestSellers.length === 0 && (
            <p className="text-center col-span-4 text-gray-400">No retro collections found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RetroCollection;
